export default "__VITE_ASSET__BgK_1A1s__"